export const AUTH_THRESHOLD = 'authorization threshold';
export const CANCELLED = 'cancelled';
export const DEFAULT = 'default';
export const INVALID_ACCESS_TOKEN = 'invalid access token';
export const PILLAR_OFFLINE = 'pillar offline';
export const UNAUTHORIZED_ACCESS = 'unauthorized access';
